import { useRequest } from 'ahooks';
import { useTranslate } from '@tolgee/react';
import { message } from 'antd';
import { getSpuMarkRecord, getStockRule, getUploadRecord, updateStockRule } from './api';
import { useContext } from 'react';
import { noop } from 'lodash-es';
import { SearchParamsContext } from './context';

let refreshFn = noop;

export const useGetStockRule = () => {
  const { t } = useTranslate();
  const { values } = useContext(SearchParamsContext);

  const { data, loading, refresh } = useRequest(() => getStockRule(values), {
    refreshDeps: [values],
    onError: () => {
      message.error(t('phrase.获取数据失败，请稍后再试'));
    },
  });

  refreshFn = refresh;

  return {
    data,
    loading,
  };
};

export const useUpdateStockRule = () => {
  const { runAsync, loading } = useRequest(
    (data: OutofStock.UpdateStockRuleParams) => updateStockRule(data),
    {
      manual: true,
      onSuccess: () => {
        setTimeout(() => {
          refreshFn?.();
        });
      },
    },
  );

  return {
    update: runAsync,
    loading,
  };
};

export const useGetSpuMarkRecord = (stockRuleId: string) => {
  const { t } = useTranslate();
  const { data, loading } = useRequest(() => getSpuMarkRecord(stockRuleId), {
    ready: !!stockRuleId,
    onError: () => {
      message.error(t('phrase.获取数据失败，请稍后再试'));
    },
  });

  return {
    data,
    loading,
  };
};

export const useGetUploadRecord = () => {
  const { t } = useTranslate();
  const { data, loading } = useRequest(() => getUploadRecord(), {
    onError: () => {
      message.error(t('phrase.获取数据失败，请稍后再试'));
    },
  });

  return {
    data,
    loading,
  };
};
